// @refresh reload
import { mount, StartClient } from "@solidjs/start/client";

export default mount(() => <StartClient />, document.getElementById("app")!);
